<div class="auth-container">
  <div class="lang-switcher-top">
    <button mat-mini-fab color="primary" (click)="lang.toggle()" [matTooltip]="'HEADER.LANGUAGE' | translate">
      {{ lang.current === 'ar' ? 'EN' : 'ع' }}
    </button>
  </div>
  <mat-card class="auth-card">
    <div class="card-content">
      <!-- Left side - Branding and Illustration -->
      <div class="left-side-section">
        <div class="branding-content">
          <h1 class="brand-title">{{ 'COMMON.APP_NAME' | translate }}</h1>
          <div class="lab-illustration">
            <div class="microscope"></div>
            <div class="test-tubes">
              <div class="tube tube-1"></div>
              <div class="tube tube-2"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right side - Form -->
      <div class="form-section">
        <div class="form-content">
          <h2 class="title">تغيير كلمة المرور</h2>
          <p class="subtitle">
            يجب تعيين كلمة مرور جديدة قبل المتابعة
            <span *ngIf="state?.username"> — <strong>{{ state?.username }}</strong></span>
          </p>

          <form [formGroup]="form" (ngSubmit)="onSubmit()" class="auth-form">
            <!-- New Password -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>*كلمة المرور الجديدة</mat-label>
              <input matInput
                     [type]="hideNew ? 'password' : 'text'"
                     formControlName="newPassword"
                     placeholder="••••••••"
                     autocomplete="new-password" />
              <button mat-icon-button matSuffix type="button"
                      (click)="hideNew = !hideNew"
                      [attr.aria-label]="'COMMON.HIDE_PASSWORD' | translate"
                      [attr.aria-pressed]="hideNew">
                <mat-icon>{{ hideNew ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              @if (f['newPassword'].touched && f['newPassword'].hasError('required')) {
                <mat-error>هذا الحقل مطلوب</mat-error>
              }
              @if (f['newPassword'].touched && f['newPassword'].hasError('minlength')) {
                <mat-error>يجب أن تكون 6 أحرف على الأقل</mat-error>
              }
            </mat-form-field>

            <!-- Confirm Password -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>*تأكيد كلمة المرور</mat-label>
              <input matInput
                     [type]="hideConfirm ? 'password' : 'text'"
                     formControlName="confirmPassword"
                     placeholder="••••••••"
                     autocomplete="new-password" />
              <button mat-icon-button matSuffix type="button"
                      (click)="hideConfirm = !hideConfirm"
                      [attr.aria-label]="'COMMON.HIDE_PASSWORD' | translate"
                      [attr.aria-pressed]="hideConfirm">
                <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              @if (f['confirmPassword'].touched && f['confirmPassword'].hasError('required')) {
                <mat-error>هذا الحقل مطلوب</mat-error>
              }
              @if (f['confirmPassword'].touched && passwordsMismatch) {
                <mat-error>كلمتا المرور غير متطابقتين</mat-error>
              }
            </mat-form-field>

            <!-- Submit Button -->
            <button mat-raised-button type="submit" class="create-btn"
                    [disabled]="form.invalid || passwordsMismatch || loading">
              @if (loading) {
                <mat-spinner diameter="20" class="btn-spinner"></mat-spinner>
              }
              @if (!loading) {
                <span>حفظ والمتابعة</span>
              }
            </button>

            <!-- Error Message -->
            @if (error) {
              <div class="error-message">{{ error }}</div>
            }

            <!-- Back to login -->
            <div class="remember-forgot" style="justify-content:center;">
              <a class="forgot-password-link" href="javascript:void(0)" (click)="backToLogin()">
                العودة لتسجيل الدخول
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </mat-card>
</div>
